import Search from "../components/Search";
import { useState } from "react";
import CountriesList from "../components/CountriesList";

const Countries = () => {
  const [userInput, setUserInput] = useState("");

  return (
    <div className="countries-page">
      <Search userInput={userInput} setUserInput={setUserInput} />
      <CountriesList userInput={userInput} />
    </div>
  );
};

export default Countries;
